import type { MouseEvent } from 'react';
import {
  Avatar,
  AvatarGroup,
  Button,
  Skeleton,
  type AvatarProps,
} from '@mui/material';
import { useInstitutionsLogo } from '@/data/catalog/institutions-logo';
import type { CourseTypes } from '@/models/catalog/course';

interface InstitutionAvatarProps extends AvatarProps {
  bgcolor?: string;
}

const InstitutionAvatar = ({ bgcolor, ...props }: InstitutionAvatarProps) => (
  <Avatar
    {...props}
    sx={{
      bgcolor,
      borderRadius: 1,
      height: 30,
      width: 30,
      border: '2px solid white !important',
    }}
    slotProps={{ img: { sx: { height: 'auto' } } }}
  />
);

interface RecommendedCoursesButtonProps {
  courseType: CourseTypes;
  onClick: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const RecommendedCoursesButton = ({
  courseType,
  onClick,
  fullWidth,
  disabled,
}: RecommendedCoursesButtonProps) => {
  const { institutions } = useInstitutionsLogo(courseType);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const institutionsNames = institutions?.map((institution) => institution.name).join(', ');

  return (
    <Button
      component="span"
      sx={{ width: fullWidth ? '100%' : 'fit-content' }}
      variant="outlined"
      onClick={handleClick}
      disabled={disabled}
      className="media-print-hide"
    >
      {institutions && institutions.length > 0 && (
        <AvatarGroup spacing={20} max={3} variant="square" sx={{ mr: 1 }} aria-label={`Instituições com cursos recomendados: ${institutionsNames}`}>
          {institutions?.map((institution) => (
            <InstitutionAvatar
              key={institution.id}
              alt=""
              src={institution.logo_url || ''}
              bgcolor={institution.logo_background_color || undefined}
            />
          ))}
        </AvatarGroup>
      )}
      {!institutions && (
        <Skeleton variant="rounded" sx={{ width: 34, height: 34, mr: 1 }} />
      )}
      Ver cursos recomendados
    </Button>
  );
};
